import script from "./PaymentMethodTag.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodTag.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodTag.vue?vue&type=style&index=0&id=0f50f035&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f50f035"]])

export default __exports__